var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Warstwa_1",
    width: 300,
    height: 228.3,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style10",
    type: "text/css"
  }, ".st0{fill:#005f42}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(44.85 36.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon12",
    d: "M196.4 17.2h-11.5l-3.7 8.2h8.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m69.2 126.2-7.8 21.7h7l.8-2.9h7.1l.9 2.9h7.1l-7.8-21.7zm3.6 6.5 2.3 7.8h-4.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon16",
    d: "M129.7 126.2H123v21.7h6.8V141l-.2-4.9 7.7 11.8h6.8v-21.7h-6.9v7l.2 4.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon18",
    d: "M183.7 126.2v21.7h7.1V141l1.7-1.7 5.3 8.6h8.5l-8.7-13.5 7.9-8.2h-8.3l-6.4 7v-7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M204.2 29c-5.7-1.1-11.4-1.8-15.8-1.8-7.2 0-12.8 1-17.2 3.6-4.5 2.7-7.7 8.5-7.7 11.7 0 3.1 1.2 6 3 8.9 1.8 2.7 3.4 4.5 5.3 6.3 1.8 1.9 13.9 10.8 15.2 12 3.2 3 5 5.5 5 8.5 0 1.8-1.3 3.6-3.7 4.9-2 1.2-5.1 1.9-9 1.9-6.4 0-11.5-1.3-16.6-5l2 12.8c6.4 1.8 12.7 3.1 19.1 3.1 4.5 0 10-.8 13.4-2.2 3.5-1.5 6.4-3.2 8.1-5.7 2-2.5 3.3-5.4 3.3-8.4 0-3.7-1.3-7.3-4.5-11.6-1.2-1.2-2.6-3-4-4.1-2-1.4-10.5-8-12.5-9.3-1.9-1.2-3.5-2.6-5.1-4.1-1.9-2.5-2.6-4.4-2.6-6.2 0-1.8.8-3.6 3.2-5.1 1.2-.8 5.2-1.5 8.9-1.5 3.9 0 9.6.7 13.9 2.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M107.6 104.5c24 0 43.5-19.4 43.5-43.3 0-24-19.5-43.4-43.5-43.4S64.1 37.2 64.1 61.2c-.1 23.9 19.4 43.3 43.5 43.3M53.1 61.2c0-30 24.4-54.2 54.4-54.2s54.3 24.2 54.3 54.2c0 29.9-24.3 54.2-54.3 54.2-30-.1-54.4-24.3-54.4-54.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M89.3 94.3c2.6-2.1 8.5-5.9 10-11.3.5-4.8-12.3-4.5-14.7-1.8-.7-3.5-.7-8.5-7.2-6.9-.5-5-.3-7.4-4.6-10.6 11.2-1 11.6-5.6 2.6-15.9 5.3-1.1 5.2-1.9 3.7-9.1 5.8 3.5 9.4 2.4 12.9-3.3 6.9 10.8 13.3 9.5 10.7-1.8 4 2 6.5-.1 7.8-3.2 2.5 1.6 4.9 0 7.1-2.9 0 2.8 2.4 7.6 7 7.5-2.3 3.4.7 5.5 2.9 5.7-9.1 11.1-3.1 15.5 7 6.4-.9 6.4.6 7.8 8.2 7.7-2.9 4.5-5.1 8-1.7 12.5-5.7 2-19.7 6.4-4.9 12.4-4.4 1.3-6.6 5.2-5.9 7.4-5.6-2.8-8.5.2-7.8 5.7-4.4.6-14.6-5.6-17.5-8.9-.9-1-2.1-1.5-2.8-.5-2.6 5.7-4.3 7.1-7 12-1.3-.6-2.8-1-5.8-1.1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M24.9 55.8c2 0 5.2-1.3 6.8-3.1 1.5-1.7 2.6-4.2 2.6-6.9 0-2.5-1.1-4.4-2.5-5.8-1.6-1.5-4.5-2.5-6.8-2.5H14.1v18.3ZM27 85.7c2.5 0 6.4-1 8.1-2.9 1.6-1.9 2.3-4.4 2.4-7.1 0-2.6-.8-5.1-2.4-6.7-1.6-1.7-5.5-2.8-8.1-2.8H14.1v19.5ZM1.7 27.8h25.6c3.3 0 7.5 1 10.5 2.8 2.9 1.8 4 2.8 5.5 5.6 1.5 2.9 1.9 4.5 2.1 7.8.2 2.9-.5 5.9-1.6 8.5-1 2.3-4.2 6.3-8.6 7.8 4.8-.2 11.3 4.5 13 7.9 1.3 2.7 2 4.9 2.2 7.8.1 2.4-.1 6.2-1 8.5-.9 2.2-2 3.8-3.8 5.4-1.6 1.4-3.9 3-6.6 4-2.7 1-6 1.1-9.4 1.1H1.7Z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M12.1 138.8h2.2c3.1 0 3.9.4 4 2.1 0 1.1-.6 1.9-2.9 1.9h-3.3zm0-7.5h2.7c2.2 0 2.6.6 2.6 1.7 0 1-.7 1.9-2.4 1.9h-3v-3.6zm-7.2-5.1v21.7h10.7c5.7 0 9.1-1.7 9.2-6.4 0-2.3-1.2-4.5-3.6-5.1 1.7-1.1 2.9-2.8 2.9-4.8 0-3.7-3.1-5.4-8.6-5.4z",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBos);
export default __webpack_public_path__ + "static/media/bos.8a4b14f417792f292fd43ac66942daad.svg";
export { ForwardRef as ReactComponent };